/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledFloatingPhoneInputTypes = {
    primary: "primary" as const,
    secondary: "secondary" as const
};

export type StyledFloatingPhoneInputTypes = typeof StyledFloatingPhoneInputTypes[keyof typeof StyledFloatingPhoneInputTypes];
